import { JournalTool } from '@addins/core/journal';

export class AddFreeTextTool extends JournalTool {
  constructor(private executor: Function) {
    super('Mobile.AddStamp', '', '', 0, executor);
    this._isEnabled = true;
  }
}
